// Disabled due to the function parameters from the API are not typed.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BASE_PATH, Configuration } from '@rocksoft/settings-sdk';
import { Observable } from 'rxjs';

@Injectable()
export class VppApplicationsRequestService {
  protected httpClient = inject(HttpClient);

  protected basePath = 'https://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor() {
    const basePath = inject(BASE_PATH, { optional: true });
    const configuration = inject(Configuration, { optional: true });

    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Gets all scheduled VPP applications across all the locations and saves them in a CSV file.
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllScheduledVppApplicationsCsv(observe?: 'body', reportProgress?: boolean): Observable<Blob>;
  public getAllScheduledVppApplicationsCsv(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Blob>>;
  public getAllScheduledVppApplicationsCsv(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
  public getAllScheduledVppApplicationsCsv(observe: any = 'body', reportProgress = false): Observable<any> {
    let headers = this.defaultHeaders;

    // Authentication (oauth2) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    // To determine the Accept header
    const httpHeaderAccepts: string[] = ['text/csv'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);

    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request('get', `${this.basePath}/integrations/mdm/vpp-applications/configurations/csv`, {
      withCredentials: this.configuration.withCredentials,
      headers,
      observe,
      reportProgress,
      responseType: 'blob', // Important for file downloads
    });
  }
}
